// extracted by mini-css-extract-plugin
module.exports = {"block":"Modal__block___36G06","footer":"Modal__footer___2VLKX","header":"Modal__header___1nqRV","body":"Modal__body___3dbMg","info":"Modal__info___1kjB6"};